module.exports = __webpack_public_path__ + "static/media/tick.6d4565d2.svg";